import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { AbwConfirmDialogComponent } from './abw-confirm-dialog.component';
import { AbwConfirmDialogService } from './abw-confirm-dialog.service';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [AbwConfirmDialogComponent],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule
    ],
    providers: [
        AbwConfirmDialogService
    ],
    entryComponents: [
        AbwConfirmDialogComponent
    ]
})
export class AbwConfirmDialogModule {
    
}